import React, { Component } from 'react';
import './style.css';
import { twitter_request_token, HeaderConfig } from 'Api/Api';
import axios from 'axios';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'


class Twitter_Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      userID: '',
      name: '',
      email: '',
      picture: '',
      access_token: '',
      loader: false,
    };
  }

  onTwitterClick = () => {
    let callback_base_url = window.location.protocol + '//' + window.location.hostname;
    axios.post(twitter_request_token, { callback_url: `${callback_base_url}${this.props.callbackUrl}` }, HeaderConfig)
      .then(({ data = {} }) => {
        const { oauth_token } = data
        window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${oauth_token}`
      })
  }

  render() {
    const { loader } = this.state;
    if (loader) {
      return (
        <FullPageSpinner />
      )
    }
    else {
      return (
        <div className="App">
          <div className="twitter-login">
            <button onClick={this.onTwitterClick}><i className="fa fa-twitter" aria-hidden="true"></i>Twitter</button>
          </div>
        </div>
      );
    }

  }
}

export default Twitter_Login;